// import React, { useEffect, useState } from "react";
// import {
//   AppShell,
//   Header,
//   Navbar,
//   ActionIcon,
//   ScrollArea,
// } from "@mantine/core";
// import {
//   Notes,
//   Signature,
//   Pencil,
//   Lock,
//   Subtask,
//   Home,
//   Paperclip,
//   Bell,
  
//   Plus,
//   Search,
//   Template,
//   LayoutSidebarLeftCollapse,
//   LayoutSidebarRightCollapse,
//   Snowman,
//   ReportMoney,
//   Mail,
//   File,
//   List
// } from "tabler-icons-react";
// // import {
// //   Notes, Home, Paperclip,
// //   Bell, BarrierBlock, Template,
// //   LayoutSidebarLeftCollapse, LayoutSidebarRightCollapse, Snowman, ReportMoney,
// // } from 'tabler-icons-react';
// import { LinksGroup } from "../../components/NavbarLinkGroup";
// import AppHeader from "../../components/Header/AppHeader";
// import HamburgerMenuAgreements from "../HamburgerMenuAgreements";
// import { selectUserData } from "../../redux/selectors";
// import { useSelector } from "react-redux";
// import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
// import { getUnseenNotifications } from "../../utilities/apis/users";

// const MainAppAgreementsManager = ({ appContent, dm=false }) => {
//   const currentUser = useSelector(selectUserData) || {};
//   const [unseenCount, setUnseenCount] = useState(0);
//   const roles = currentUser.userRole || [];
//   console.log("currentUser: ", currentUser.id);
//   useEffect(()=>{
//     const getUnseenNotificationCount = async() =>{
//       const response = await apiWrapWithErrorWithData(getUnseenNotifications());
//       if(response.success){
//         setUnseenCount(response.count);
//       }
//     }
//     getUnseenNotificationCount();
//   }, []);
//   const loginAs = currentUser.loginAs;

//   const mockdata = [
//     !dm ?{
//       label: "dashboard",
//       icon: Home,
//       link: "/app/agreements_manager",
//     }: null,
//     !dm? {
//       label: `notifications`,
//       icon: Bell,
//       link: "/app/agreements_manager/notifications",
//       hasNumber : `${unseenCount}`,
//     }: null,

//     !dm ?{
//       label: "my agreements",
//       icon: Paperclip,
//       link: "/app/agreements_manager/agreements-list",
//     }: null,
//     (!dm && (loginAs.id === 3 || loginAs.id === 4 || loginAs.id === 1 || loginAs.id === 2))
//       ? {
//           label: "new agreement",
//           icon: Plus,
//           initiallyOpened: false,
//           links:[
//             {
//               label: "individual agreement",
//               link: "/app/agreements_manager/agreements/new",
//             },
//             {
//               label: "bulk agreements",
//               link: "/app/agreements_manager/agreements/new-bulk",
//             },
//             {
//               label: "legacy agreement",
//               link: "/app/agreements_manager/agreements/new-legacy-agreement",
//             },
//             {
//               label: "bulk legacy agreements",
//               link: "/app/agreements_manager/agreements/bulk-legacy-agreement",
//             },
//           ]
//         }
//       : null,
//     // loginAs.id === 5 || loginAs.id === 6
//     //   ? {
//     //       label: "Review",
//     //       icon: Search,
//     //       link: "/app/agreements_manager/review",
//     //     }
//     //   : null,
//     // loginAs.id === 1 || loginAs.id === 4
//     //   ? {
//     //       label: "Signature",
//     //       icon: Pencil,
//     //       link: "/app/agreements_manager/signature",
//     //     }
//     //   : null,
//     (!dm && (loginAs.id === 1 || loginAs.id === 4 || loginAs.id === 2 ||loginAs.id === 3))
//       ? {
//           label: "docs locker",
//           icon: Lock,
//           link: "/app/agreements_manager/docs-locker",
//         }
//       : null,
//       dm ? {
//         label:"documents",
//         // initiallyOpened: false,
//         icon: File,
//         link: "/app/corporatedocuments",
//       //   links:[
//       //   {
//       //     label: "corporate documents",
//       //     link: "/app/agreements_manager/corporatedocuments",
//       //   },
//       //   // {
//       //   //   label: "my documents",
//       //   //   link: "/app/agreements_manager/mydocuments",
//       //   // },
//       // ]
//       }: null,
//       // !dm ? {
//       //   label:"emails",
//       //   initiallyOpened: false,
//       //   icon: Mail,
//       //   links:[
//       //   {
//       //     label: "inbox",
//       //     link: "/app/agreements_manager/emails/inbox",
//       //   },
//       //   {
//       //     label: "outbox",
//       //     link: "/app/agreements_manager/emails/outbox",
//       //   },]
//       // }: null,
       
//     (!dm &&  (loginAs.id === 1 || loginAs.id === 2 || loginAs.id === 4))
//       ? {
//           label: "templates",
//           icon: Template,
//           initiallyOpened: true,
//           links: [
//             {
//               label: "agreements",
//               link: "/app/agreements_manager/templates/agreement",
//             },
//             {
//               label: "clauses",
//               link: "/app/agreements_manager/templates/clause",
//             },
//           ],
//         }
//       : null,
//     //   loginAs.id === 1 || loginAs.id === 2 || loginAs.id === 4?
//     // {
//     //   label: "obligations",
//     //   icon: Subtask,
//     //   initiallyOpened: true,
//     //   link: "https://obligationapp.truecounsel.in/",

//     // }: null,
//     !dm? {
//       label: `oblligations`,
//       icon: List,
//       link: "/app/agreements_manager/obligations",
//     }: null,

//     loginAs.id === 1 || loginAs.id === 2
//       ? {
//           label: "team manager",
//           icon: Snowman,
//           link: "/app/agreements_manager/service-providers",
//         }
//       : null,
//   ].filter(Boolean);

//   const links = mockdata.map((item) => (
//     <LinksGroup {...item} key={item.label} />
//   ));

//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

//   return (
//     <AppShell
//       padding="md"
//       navbar={
//         <Navbar
//           style={{ backgroundColor: "#F1F4FA", padding: "10px 0 0 0" }}
//           width={{ base: sidebarCollapsed ? 50 : 250 }}
//           height="calc(100vh - 65px)"
//           p="xs"
//         >
//           <Navbar.Section grow component={ScrollArea}>
//             <div className="flex flex-col">
//               <div className="flex justify-end">
//                 <ActionIcon
//                   color="#1b6f8d"
//                   onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
//                   style={{ cursor: "pointer", marginRight: "9%" }}
//                 >
//                   {sidebarCollapsed ? (
//                     <LayoutSidebarRightCollapse color="#1b6f8d" />
//                   ) : (
//                     <LayoutSidebarLeftCollapse color="#1b6f8d"/>
//                   )}
//                 </ActionIcon>
//               </div>
//               {!sidebarCollapsed && <div>{links}</div>}
//             </div>
//           </Navbar.Section>
//         </Navbar>
//       }
//       header={
//         <Header height={65}>
//           <AppHeader />
//         </Header>
//       }
//     >
//       <div
//         style={{ backgroundColor: "#FFFFFF", minHeight: "calc(100vh - 100px)" }}
//       >
//         {appContent}
//       </div>
//     </AppShell>
//   );
// };

// export default MainAppAgreementsManager;


import React, { useEffect, useState } from "react";
import {
  AppShell,
  Header,
  Navbar,
  ActionIcon,
  ScrollArea,
} from "@mantine/core";
import {
  Home,
  Bell,
  Paperclip,
  Plus,
  Lock,
  File,
  Template,
  List,
  Snowman,
  LayoutSidebarLeftCollapse,
  LayoutSidebarRightCollapse,
} from "tabler-icons-react";
import { LinksGroup } from "../../components/NavbarLinkGroup";
import AppHeader from "../../components/Header/AppHeader";
import { selectUserData } from "../../redux/selectors";
import { useSelector } from "react-redux";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import { getUnseenNotifications } from "../../utilities/apis/users";
import {MyBagIcon, DocLockerIcon, NotificationIcon, PlusIcon, TemplatesIcon, HomeIcon, ObligationIcon, TeamMangerIcon } from "../../new-icons/icon";
import "./sidebar.css";

const MainAppAgreementsManager = ({ appContent, dm = false }) => {
  const currentUser = useSelector(selectUserData) || {};
  const [unseenCount, setUnseenCount] = useState(0);

  useEffect(() => {
    const getUnseenNotificationCount = async () => {
      const response = await apiWrapWithErrorWithData(getUnseenNotifications());
      if (response.success) {
        setUnseenCount(response.count);
      }
    };
    getUnseenNotificationCount();
  }, []);

  const loginAs = currentUser.loginAs || {};

  const mockdata = [
    !dm ? {
      label: "Overview", // Renamed from dashboard
      icon: HomeIcon,
      link: "/app/agreements_manager",
    } : null,
    !dm ? {
      label: "Alerts", // Renamed from notifications
      icon: NotificationIcon,
      link: "/app/agreements_manager/notifications",
      hasNumber: unseenCount > 99 ? "99+" : `${unseenCount}`,
    } : null,
    !dm ? {
      label: "In Progress", // Renamed from my agreements
      icon: MyBagIcon,
      link: "/app/agreements_manager/agreements-list",
    } : null,
    (!dm && (loginAs.id === 3 || loginAs.id === 4 || loginAs.id === 1 || loginAs.id === 2))
      ? {
          label: "Create", // Renamed from new agreement
          icon: PlusIcon,
          initiallyOpened: false,
          links: [
            { label: "New Contract", link: "/app/agreements_manager/agreements/new" },
            { label: "Bulk Contracts", link: "/app/agreements_manager/agreements/new-bulk" },
            { label: "Legacy Contract", link: "/app/agreements_manager/agreements/new-legacy-agreement" },
            { label: "Bulk Legacy Contracts", link: "/app/agreements_manager/agreements/bulk-legacy-agreement" },
          ]
        }
      : null,
    (!dm && (loginAs.id === 1 || loginAs.id === 4 || loginAs.id === 2 || loginAs.id === 3))
      ? {
          label: "Repository", // Renamed from docs locker
          icon: DocLockerIcon,
          link: "/app/agreements_manager/docs-locker",
        }
      : null,
    dm ? {
        label: "documents",
        icon: File,
        link: "/app/corporatedocuments",
      } : null,
    (!dm && (loginAs.id === 1 || loginAs.id === 2 || loginAs.id === 4))
      ? {
          label: "Templates",
          icon: TemplatesIcon,
          initiallyOpened: true,
          links: [
            { label: "Contracts", link: "/app/agreements_manager/templates/agreement" },
            { label: "Clauses", link: "/app/agreements_manager/templates/clause" },
          ],
        }
      : null,
    !dm ? {
      label: "Obligations",
      icon: ObligationIcon,
      link: "/app/agreements_manager/obligations",
    } : null,
    (loginAs.id === 1 || loginAs.id === 2)
      ? {
          label: "Team Manager",
          icon: TeamMangerIcon,
          link: "/app/agreements_manager/service-providers",
        }
      : null,
  ].filter(Boolean);

  // --- MAPPING TO GROUPS ---
  const menuKeys = ["Overview", "Alerts", "In Progress", "Create"];

  const menuItems = mockdata.filter((item) => menuKeys.includes(item.label));
  const otherItems = mockdata.filter((item) => !menuKeys.includes(item.label));

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <AppShell
      padding="md"
      navbar={
        <Navbar
          width={{ base: sidebarCollapsed ? 60 : 250 }}
          height="calc(100vh - 65px)"
          p={0}
          style={{ backgroundColor: "#EEF2F3" }}
        >
          <Navbar.Section grow component={ScrollArea}>
            <div className="flex flex-col">
              
              <span className="flex justify-end pr-3 pt-2">
                <ActionIcon onClick={() => setSidebarCollapsed(!sidebarCollapsed)}>
                  {sidebarCollapsed ? (
                    <LayoutSidebarRightCollapse color="#649fb1" />
                  ) : (
                    <LayoutSidebarLeftCollapse color="#649fb1" />
                  )}
                </ActionIcon>
              </span>

              {!sidebarCollapsed && (
                <div className="pt-2" style={{ marginTop: "-45px" }}>
                  <div className="sidebar-heading">MENU</div>
                  {menuItems.map((item) => (
                    <LinksGroup {...item} key={item.label} />
                  ))}

                  <div className="sidebar-heading mt-4">OTHERS</div>
                  {otherItems.map((item) => (
                    <LinksGroup {...item} key={item.label} />
                  ))}
                </div>
              )}
            </div>
          </Navbar.Section>
        </Navbar>
      }
      header={
        <Header height={65}>
          <AppHeader />
        </Header>
      }
    >
      <div style={{ backgroundColor: "#fff", minHeight: "100%" }}>
        {appContent}
      </div>
    </AppShell>
  );
};

export default MainAppAgreementsManager;